import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {

	PUT_PROMO_VOUCHERS: type('[PromoVouchers] Promo and Voucher Update'),
	RESET: type('[PromoVouchers] Reset')
};


export class PutPromoVouchersAction implements Action {
	type = ActionTypes.PUT_PROMO_VOUCHERS;


	/**
	 *Creates an instance of PutPromoVouchersAction.
	 * @param {*} payload
	 * @memberof PutPromoVouchersAction
	 */
	constructor(public payload: any) { }
}


export class ResetAction implements Action {
	type = ActionTypes.RESET;

	constructor(public payload?) { }
}

export type Actions = ResetAction | PutPromoVouchersAction;
